module.exports = __webpack_public_path__ + "img/voice.50267b89.png";